var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import React, { useEffect } from 'react';
import { Alert, Snackbar } from '@mui/material';
export var Notification = function (_a) {
    var _b;
    var props = _a.props, handleFormChange = _a.handleFormChange;
    var handleClose = function (event, reason) {
        if (reason === 'clickaway')
            return;
        handleFormChange(__assign(__assign({}, props), { open: false }));
    };
    useEffect(function () { }, [props, handleFormChange]);
    return (_jsx(Box, __assign({ sx: { width: 500, position: 'absolute' } }, { children: _jsx(Snackbar, __assign({ open: (_b = props === null || props === void 0 ? void 0 : props.open) !== null && _b !== void 0 ? _b : false, onClose: handleClose, autoHideDuration: props === null || props === void 0 ? void 0 : props.duration, anchorOrigin: { vertical: (props === null || props === void 0 ? void 0 : props.vertical) ? props === null || props === void 0 ? void 0 : props.vertical : 'top', horizontal: 'right' } }, { children: _jsx(Alert, __assign({ severity: props === null || props === void 0 ? void 0 : props.severity, onClose: handleClose, action: props === null || props === void 0 ? void 0 : props.action }, { children: props === null || props === void 0 ? void 0 : props.message })) })) })));
};
